export function DropdownArrow({ color = "#fff" }: { color?: string }) {
  return (
    <svg width="6" height="11" viewBox="0 0 6 11" fill="none">
      <path d="M1 1L5 5.5L1 10" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" shapeRendering="geometricPrecision" />
    </svg>
  );
}
